import { useSettings } from './useSettings/useSettings';

/** Objects passed to `generateUseUseSettings` must expose the WL `slug` (matches backend). */
export type SettingsSlugMarker = {
  readonly slug: string;
};

function normalizeSlug(slug: string): string {
  return slug.trim().toLowerCase();
}

/**
 * Returns a hook that is true when `useSettings().slug` matches one of the
 * given marker slugs. Compares normalized strings — not object identity — so
 * it works in production where `useSettings()` always returns a fresh
 * `WebsiteSettings` instance.
 */
export const generateUseUseSettings = (
  settings: SettingsSlugMarker | ReadonlyArray<SettingsSlugMarker>,
) => {
  const useUseSettings = () => {
    const { settings: currentSettings } = useSettings();
    const currentSlug = currentSettings.slug;
    if (currentSlug.length === 0) {
      return false;
    }
    const normalizedCurrent = normalizeSlug(currentSlug);
    const relevantSettings = Array.isArray(settings) ? settings : [settings];
    return relevantSettings.some(
      (potential) => normalizeSlug(potential.slug) === normalizedCurrent,
    );
  };
  return useUseSettings;
};
